<script>
import moment from "moment";
import keyBy from "lodash/keyBy";
export default {
  data() {
    const patientId = this.$route.params.patientId;
    return {
      checkBoxSelect: true,
      value: new Date(),
      patientId,
      rangeDate: {}
    };
  },
  watch: {
    value(value) {
      this.loadData(moment(value));
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData(date) {
      let paramsDate = date || moment();
      let params = {
        year: paramsDate.year(),
        month: paramsDate.month() + 1
      };
      let patientId = this.patientId;
      let data = await this.$http.getPatientTrainCalendar(patientId, params);
      this.rangeDate = keyBy(data, "date");
    },
    onClick(data) {
      console.log(data);
    }
  }
};
</script>

<template>
  <div class="patientManagementCalenderIndex">
    <el-calendar class="trainCalendar" v-model="value">
      <template slot="dateCell" slot-scope="{date, data}">
        <p
          :class="data.isSelected ? 'is-selected' : ''"
        >{{ data.day.split('-').slice(1).join('-') }}</p>
        <gameRateStar
          v-if="rangeDate[data.day] && rangeDate[data.day].startLevel >= 0 && rangeDate[data.day].startLevel < 10"
          class="gameRateStar"
          :score="rangeDate[data.day].startLevel"
        />
      </template>
    </el-calendar>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.patientManagementCalenderIndex {
  .trainCalendar {
    width: 70%;
    margin-left: 10%;
    .is-selected {
      color: #1989fa;
    }
    .el-calendar-table .el-calendar-day {
      height: 50px;
    }
    .el-calendar-table tr td:first-child {
      border: none;
    }
    .el-calendar-table tr:first-child td {
      border: none;
    }
    .el-calendar-table td {
      border: none;
      text-align: center;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/patientManagement/trainCalendar.vue